import { Box, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const InnerCard = styled(Box)<{ flex?: number }>`
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  background-color: ${({ theme }) => getThemeColor('white', theme)};
  border-radius: 16px;
  min-width: 370px;
  overflow: hidden;

  flex: ${({ flex }) => flex ?? undefined};
`
